import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Text from '../Text';

function Value(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "span",
    grow: 1,
    shrink: 1,
    fontSize: "inherit",
    lineHeight: "inherit",
    textAlign: "left",
    truncate: true
  }, props));
}

export default Value;